import {
  fetchCollection
} from './index'

import { technicianServiceSummarySchema } from '../schemas'

export const WORK_ORDER_TECHNICIAN_SUMMARIES_REQUEST = 'WORK_ORDER_TECHNICIAN_SUMMARIES_REQUEST'
export const WORK_ORDER_TECHNICIAN_SUMMARIES_SUCCESS = 'WORK_ORDER_TECHNICIAN_SUMMARIES_SUCCESS'
export const WORK_ORDER_TECHNICIAN_SUMMARIES_FAILURE = 'WORK_ORDER_TECHNICIAN_SUMMARIES_FAILURE'

export function fetchTechnicianServiceSummariesForWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/technician_service_summaries`,
    key: 'technicianServiceSummaries',
    schema: technicianServiceSummarySchema,
    actions: [
      WORK_ORDER_TECHNICIAN_SUMMARIES_REQUEST,
      WORK_ORDER_TECHNICIAN_SUMMARIES_SUCCESS,
      WORK_ORDER_TECHNICIAN_SUMMARIES_FAILURE
    ],
    responseInterceptor: (response) => ({ ...response, workOrderId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/technician-service-summaries.js